import React from 'react';
import { useTranslation } from 'next-i18next';
import Router from 'next/router';
import { filter } from 'lodash';
import { useRouter } from 'next/router';
import { useWebshopState } from '@context/webshop';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

function IndexPage() {
  const { t } = useTranslation('webshop');
  const router = useRouter();
  const { id } = router.query;
  const { fetchWebshop, fetchUserCart } = useWebshopState();

  const goToHome = () => {
    Router.push({
      pathname: `/${id}`,
    });
  };

  React.useEffect(() => {
    const { id } = router.query;
    if (id) {
      fetchWebshop(id);
      if (filter(JSON.parse(localStorage.getItem('userData')), { webShopToken: id }).length > 0) {
        const userData = filter(JSON.parse(localStorage.getItem('userData')), { webShopToken: id })[0];
        fetchUserCart({
          webShopToken: id,
          userId: userData.userId,
        });
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container my-24 px-6 mx-auto">
      <section className="mb-32 text-gray-800 text-center">
        <div className="px-6 py-12 md:px-12">
          <h2 className="text-5xl my-12 font-bold tracking-tight">About Vourity</h2>
        </div>
        <div className="flex justify-center">
          <div className="block p-6 rounded-lg shadow-lg bg-white text-left grid justify-items-stretch">
            <p>Vourity is a cloud based service that enable companies to sell and manage digital Vouchers, Passes, Tickets, Membership cards and Coupons. This site enable you to order Passes and Vouchers.</p>
            <p></p>
            <h1>Our story</h1>
            <p>Vourity AB was founded in Sweden 2018. The company was born out of frustrations the founders experienced in every day situations when dealing with Vouchers, Gift-cards and Discount Coupons. They started looking for solutions and services that could do it better. Something they would like to have and use themselves every day. In the process they found out that also many friends shared the same frustration.</p>
            <p>So they set out on a journey to do something better than what existed on the market.</p>
            <p></p>
            <h1>Redefining Vouchers</h1>
            <p>Many existing Vouchers, Coupons and Gift-cards are distributed on paper or various types of plastic cards. This is fine in some cases but often you risk forget to bring that coupon to the shop, they get lost or expire. With Vourity you keep your (Vourity issued) Gift-cards, Passes, Coupons, Vouchers, Tickets and Membership cards in one app on your phone. You always have them with you, so you don’t risk losing out on your deals, gift cards expiring, or coupons getting lost in the laundry.</p>
            <h1>Company information</h1>
            <p>Vourity AB</p>
            <p>c/o Quick office 4-040, Råsta strandväg 13C</p>
            <p>169 79 Solna</p>
            <p>Sweden</p>
            <p>Company Registration Number: 559140-9734</p>
            <p>EU VAT Number: SE559140973401</p>
            <a href="https://vourity.com" target="_blank">
              Vourity Company Web
            </a>
            <p></p>
            <button type="button" onClick={() => goToHome()} className="mt-[20px] flex w-[180px] my-0 mx-auto px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
              {t('webshop.BACK_TO_START_PAGE')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export const getStaticPaths = async () => {
  return {
    paths: ['/id/about'],
    fallback: true,
  };
};

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['webshop'])),
    },
  };
};

export default IndexPage;
